<div class="headerFlexW pr-4 m-3" *ngIf="!fieldsUpdate">
    <div class="content-block">
        <p class="bread-crumbs"><a [routerLink]="['/dash/companies/']">Empresas</a> / Nueva empresa</p>
        <h2 class="">Empresas</h2>
    </div>
</div>


<div class="headerFlexW pr-4 m-3" *ngIf="fieldsUpdate">
    <div class="content-block">
        <p class="bread-crumbs"><a [routerLink]="['/dash/companies/']">Empresas</a> / Editar tu empresa</p>
        <h2 class="">Empresas</h2>
    </div>
</div>

<div class="dx-card content-block pt-3">
    <!-- Section Container  -->
    <div class="flex flex-nowrap">
        <div class=" responsive-paddings flex-grow-1">
            <h3 class="">Datos generales</h3>
            <div class="round-border-2 p-3">
                <div class='dx-field'>
                    <div class='dx-field-label'>Nombre de la empresa</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]="company.companyName">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Razón social</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]="company.companyLegalName">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>RFC</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]="company.rfc" class="uper-case">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Teléfono</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.companyPhone' mask="+52 (000) 000-0000">
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Nacionalidad</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]="company.nacionalidad" class="uper-case">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Programa</div>
                    <div class='dx-field-value'>
                        <dx-select-box [dataSource]="programsObj" displayExpr="name" valueExpr=""
                            (onValueChanged)="checkPrograms($event.value)">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
            </div>
        </div>
        <div class=" responsive-paddings flex-grow-1">
            <h3 class="">Datos de contacto</h3>
            <div class="round-border-2 p-3">
                <div class='dx-field'>
                    <div class='dx-field-label'>Nombre de contacto</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.contactName'>
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Apellido paterno</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.contactLastName'>
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Apellido materno</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.contactSecondLastName'>
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Teléfono de contacto</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.contactPhone' mask="+52 (000) 000-0000">
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Email</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.contactEmail'>
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                                <dxi-validation-rule type="email" message="Email es inválido">
                            </dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Puesto</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.contactJobPosition' class="uper-case">
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field" style="margin: 0">
                    <div class="dx-field-label">Administrar usuarios sin App {{company.userWithNoApp}}</div>
                    <div class="dx-field-value">
                        <dx-switch (onValueChanged)="onValueChangedApp($event.value)" [value]="company.userWithNoApp"></dx-switch>
                    </div>
                </div>
                <div class="dx-field" style="margin: 0" *ngIf="!company.cuentaClabeSTP">
                    <div class="dx-field-label">Asignar una CLABE (STP)</div>
                    <div class="dx-field-value">
                        <dx-switch (onValueChanged)="onValueChangedClabeSTP($event.value)" [value]="generateClabeSTP"></dx-switch>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Es empresa - subempresa</div>
                    <div class="dx-field-value">
                        <dx-switch (onValueChanged)="onValueChangedIsBroker($event.value)" [value]="isBroker"></dx-switch>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Flujo de autorización de solicitudes</div>
                    <div class="dx-field-value">
                        <dx-switch (onValueChanged)="onValueChangedIsRequest($event.value)" [value]="isRequest"></dx-switch>
                    </div>
                </div>                
            </div>
        </div>
    </div>
    <!-- Section Container  -->
    <div class="flex flex-nowrap">
        <div class=" responsive-paddings flex-grow-1">
            <h3 class="">Dirección de la empresa</h3>
            <div class="round-border-2 p-3">
                <div class='dx-field'>
                    <div class='dx-field-label'>Calle</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.address.street' class="uper-case">
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Número Exterior</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.address.number'>
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Número Interior</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.address.numberInt'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Colonia</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.address.neighborhood' class="uper-case">
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Ciudad</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.address.city' class="uper-case">
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <!-- COMPLEMENTO DIRECCION -->
                <div class='dx-field'>
                    <div class='dx-field-label'>Pais</div>
                    <div class='dx-field-value'>
                        <dx-select-box [dataSource]="countriesArr" displayExpr="name" valueExpr="code"
                            [(value)]="company.address.country" isRequired="true">
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Estado</div>
                    <div class='dx-field-value'>
                        <dx-select-box [dataSource]="statesArr" displayExpr="nombre" valueExpr="nombre"
                            [(value)]="company.address.state" isRequired="true">
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Código postal</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.address.zip'>
                            <dx-validator>
                                <dxi-validation-rule type='required' message='Requerido'></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
            </div>
        </div>
        <div class=" responsive-paddings flex-grow-1">
            <h3 class="">Datos Bancarios</h3>
            <div class="round-border-2 p-3">
                <div class='dx-field'>
                    <div class='dx-field-label'>Entidad Bancaria</div>
                    <div class='dx-field-value'>
                        <dx-select-box [dataSource]="bancos" displayExpr="name" valueExpr="name"
                            [(value)]="company.bank.name" >
                        </dx-select-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Titular de la cuenta</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.bank.titular'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Cuenta</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.bank.account'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Clabe</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.bank.clabe'>
                        </dx-text-box>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Section Container  -->
    <div class="flex flex-nowrap">
        <div class=" responsive-paddings flex-grow-1">
            <h3 class="">Giro de la empresa</h3>
            <div class="round-border-2 p-3">
                <div class='dx-field'>
                    <div class='dx-field-label'>Giro</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.giro.name' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Section Container  -->
    <div class="flex flex-nowrap">
        <div class=" responsive-paddings flex-grow-1">
            <h3 class="">Acta Constitutiva</h3>
            <div class="round-border-2 p-3">
                <div class='dx-field'>
                    <div class='dx-field-label'>Escritura pública número</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.actaConstitutiva.escrituraPublica'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Fecha de constitución</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.actaConstitutiva.fechaConstitucion'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Nombre del fedatario</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.actaConstitutiva.nombreFedatario'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Notario público titular</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.actaConstitutiva.notarioPublicoTitular'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Registro público</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.actaConstitutiva.registroPublico'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Ciudad</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.actaConstitutiva.ciudad' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Folio mercantil</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.actaConstitutiva.folioMercantil'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Fecha de inscripción</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.actaConstitutiva.fechaInscripcion'>
                        </dx-text-box>
                    </div>
                </div>
            </div>
        </div>
        <div class=" responsive-paddings flex-grow-1">
            <h3 class="">Modificaciones a los estatutos</h3>
            <div class="round-border-2 p-3">
                <div class='dx-field'>
                    <div class='dx-field-label'>Escritura pública número</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.modificacionesEstatutos.escrituraPublica'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Fecha de constitución</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.modificacionesEstatutos.fechaConstitucion'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Nombre del fedatario</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.modificacionesEstatutos.nombreFedatario'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Notario público titular</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.modificacionesEstatutos.notarioPublicoTitular'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Registro público</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.modificacionesEstatutos.registroPublico'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Ciudad</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.modificacionesEstatutos.ciudad' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Folio mercantil</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.modificacionesEstatutos.folioMercantil'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Fecha de inscripción</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.modificacionesEstatutos.fechaInscripcion'>
                        </dx-text-box>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Section Container  -->
    <div class="flex flex-nowrap">
        <div class=" responsive-paddings flex-grow-1">
            <div class="flex flex-nowrap flex-space-between flex-align-center">
                <h3 class="">Accionistas</h3>
                <div class="">
                    <dx-button text="" icon="plus" type="default" (onClick)="addAccionista()" *ngIf="company.accionistas.length < 4">
                    </dx-button>
                </div>
            </div>
            <div class="round-border-2 p-3" *ngFor="let accionista of company.accionistas">
                <div class='dx-field'>
                    <div class='dx-field-label'>Accionista</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='accionista.nombreAccionista'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>RFC</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='accionista.rfc' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
                <div class="flex flex-nowrap flex-space-between flex-align-center"> 
                    <div class='dx-field-label'>Borrar accionista</div>
                    <dx-button id="deleteButton" icon="fas fa-trash ico-sm" (onClick)="deleteAccionista(accionista)" ngClass="danger-Color"></dx-button>
                </div>
            </div>
            <h3 class="">Administrador</h3>
            <div class="round-border-2 p-3">
                <div class='dx-field'>
                    <div class='dx-field-label'>Administrador (si aplica)</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.administrador.nombreAdministrador'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>RFC</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.administrador.rfcAdministrador' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
            </div>
        </div>
        <div class=" responsive-paddings flex-grow-1">
            <h3 class="">Representante legal</h3>
            <div class="round-border-2 p-3">
                <div class='dx-field'>
                    <div class='dx-field-label'>Nombre completo</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.representanteLegal.name'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Fecha de nacimiento</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.representanteLegal.fechaNacimiento'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Email</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.representanteLegal.email'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>RFC</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.representanteLegal.rfc' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>C.U.R.P</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.representanteLegal.curp' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Documento con el que se identifico</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.representanteLegal.tipoDocumentoId' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Autoridad que lo emite</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.representanteLegal.autoridadQueEmiteDocumentoId' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Numero de documento</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.representanteLegal.numeroDocumentoId' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Actividad</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.representanteLegal.actividad' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
            </div>
            <h3 class="">Poder del representante legal</h3>
            <div class="round-border-2 p-3">
                <div class='dx-field'>
                    <div class='dx-field-label'>Escritura pública número</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.poderRepresentanteLegal.escrituraPublica'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Fecha de constitución</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.poderRepresentanteLegal.fechaConstitucion'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Nombre del fedatario</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.poderRepresentanteLegal.nombreFedatario'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Notario público titular</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.poderRepresentanteLegal.notarioPublicoTitular'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Registro público</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.poderRepresentanteLegal.registroPublico'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Ciudad</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.poderRepresentanteLegal.ciudad' class="uper-case">
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Folio mercantil</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.poderRepresentanteLegal.folioMercantil'>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Fecha de inscripción</div>
                    <div class='dx-field-value'>
                        <dx-text-box [(value)]='company.poderRepresentanteLegal.fechaInscripcion'>
                        </dx-text-box>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="dx-field flex-end  responsive-paddings" *ngIf="!fieldsUpdate">
        <dx-button id="button" [useSubmitBehavior]="true" type="default" (onClick)="onFormSubmit($event)"
            text="Guardar Compañía" [visible]="btnIsDisabled">
        </dx-button>
    </div>
    <div class="dx-field flex-end  responsive-paddings" *ngIf="fieldsUpdate">
        <dx-button id="button" [useSubmitBehavior]="true" type="default" (onClick)="onFormSubmitUpdate($event)"
            text="Editar Compañía" [visible]="btnIsDisabled">
        </dx-button>
    </div>
</div>